import { useRef, useState } from "react";
import { toast } from "sonner";
import api from "./api";

// Dictée : enregistre le micro puis transcrit via l'IA (Whisper).
export function useDictation(onText) {
  const [rec, setRec] = useState(false);
  const [transcribing, setTranscribing] = useState(false);
  const mr = useRef(null);

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const type = MediaRecorder.isTypeSupported?.("audio/webm") ? "audio/webm" : "audio/mp4";
      const r = new MediaRecorder(stream, { mimeType: type });
      const chunks = [];
      r.ondataavailable = (e) => e.data.size && chunks.push(e.data);
      r.onstop = async () => {
        stream.getTracks().forEach((t) => t.stop());
        setTranscribing(true);
        try {
          const fd = new FormData();
          fd.append("file", new Blob(chunks, { type }), type === "audio/webm" ? "question.webm" : "question.mp4");
          const { data } = await api.post("/ai/transcribe", fd);
          if (data.text) onText(data.text); else toast.error("Je n'ai rien entendu, réessayez.");
        } catch (e) { toast.error(e?.response?.data?.detail || "Transcription impossible"); }
        finally { setTranscribing(false); }
      };
      r.start(); mr.current = r; setRec(true);
    } catch { toast.error("Micro inaccessible : autorisez-le dans votre navigateur."); }
  };
  const stop = () => { mr.current?.stop(); setRec(false); };
  return { rec, transcribing, start, stop };
}

// Envoie un message à l'IA et diffuse la réponse au fil de l'eau.
export async function streamChat(sessionId, message, onDelta) {
  const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/ai/chat`, {
    method: "POST", credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id: sessionId, message }),
  });
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n"); buf = parts.pop();
    parts.forEach((p) => {
      if (!p.startsWith("data: ")) return;
      let d;
      try { d = JSON.parse(p.slice(6)); } catch { return; }
      if (d.delta) onDelta(d.delta);
      if (d.error) toast.error("L'IA est indisponible");
    });
  }
}
